import { EVENTS } from '@/lib/consts.js'
import { useCore } from '@/composables/core/index.js'
import { useLogger } from '@booksy-com/vue-tools'
import { useEmitter } from '@/composables/emitter/index.js'
import { useReady } from '@/composables/ready/index.js'

import { PUSH_TYPES, PUSH_REDIRECTS, PUSH_REDIRECT_ROUTES } from './consts.js'
import { path } from 'ramda'
import { notificationAction } from '@/lib/notifications.js'
import { useDefaultRedirect } from '@/composables/default-redirect/index.js'

const logger = useLogger('push-notifications')

const _redirect = ({ target_type }) => {
  const { router, store } = useCore()
  const defaultRedirect = useDefaultRedirect()

  return new Promise((resolve) => {
    const redirection = PUSH_REDIRECTS[target_type]
    const routeName = path(['currentRoute', 'value', 'name'], router)

    if (redirection === PUSH_REDIRECT_ROUTES.DEFAULT) {
      store.dispatch('business/reloadBusiness').then(() => defaultRedirect()).finally(resolve)
    } else if (redirection === PUSH_REDIRECT_ROUTES.CALENDAR && routeName !== PUSH_REDIRECT_ROUTES.CALENDAR) {
      router.push({ name: 'calendar' }).then(resolve)
    } else {
      resolve()
    }
  })
}

const _openDefaultPush = ({ type, data }) => {
  logger.log('openDefaultPush started', { type, data })

  const target_type = path(['type'], data)
  const target_id = path(['args', '0'], data)
  const payload = {
    target_type,
    target_id,
  }

  return _redirect({ target_type })
    .then(() => {
      return notificationAction({
        ...payload,
      })
    })
    .catch(e => {
      logger.error(e)
    })
    .finally(() => {
      logger.log('openDefaultPush settled', { type, data })
    })
}

const openPush = ({ type, data }) => {
  if (type === PUSH_TYPES.DEFAULT) {
    return _openDefaultPush({ type, data })
  }
  logger.error(`push type: ${type} is not recognized`)
}

const init = () => {
  const emitter = useEmitter()

  // emit examples:
  // document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { name: 'push.open', detail: { name: 'push.open', data: {type: 'booking', args: ['36452745']} } }))
  // document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { name: 'push.open', detail: { name: 'push.open', data: {type: 'calendar'} } }))
  // document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { name: 'push.open', detail: { name: 'push.open', data: {type: 'agenda'} } }))
  // document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { name: 'push.open', detail: { name: 'push.open', data: {type: 'trial_end'} } }))
  // document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { name: 'push.open', detail: { name: 'push.open', data: {type: 'trial_end_blocked'} } }))
  // document.dispatchEvent(new CustomEvent('BooksyWebViewMessage', { name: 'push.open', detail: { name: 'push.open', data: {type: 'services'} } }))
  emitter.on(EVENTS.WEB_VIEW_PUSH_OPEN, data => {
    useReady().whenReady.then(() => {
      logger.log(EVENTS.WEB_VIEW_PUSH_OPEN, data)
      return openPush({
        type: PUSH_TYPES.DEFAULT,
        data,
      })
    })
  })
}

export function usePushNotifications () {
  return {
    init,
    openPush,
    PUSH_TYPES,
  }
}
